
import React from 'react';

export default function DonateHeroSection() {
  return (
    <>
      <section className="pt-32 pb-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-6xl md:text-7xl font-bold text-black mb-8 leading-tight">
            Your Support
            <br />
            Delivers Oxygen.
          </h1>

          <p className="text-2xl text-gray-600 leading-relaxed max-w-3xl mx-auto mb-4">
            Your support helps bring oxygen awareness and access to families and communities that need it most.
          </p>
          <p className="text-xl text-gray-500 leading-relaxed max-w-3xl mx-auto mb-8">
            Every contribution directly enables screening, education, and supplementation initiatives.
          </p>

          {/* Trust footer line */}
          <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-6 py-3 mt-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-government-line text-[#12B6B6] text-base"></i>
            </div>
            <span className="text-sm text-gray-600 font-medium">
              Diatomic Life Foundation is a registered Section-8 non-profit with 80G tax exemption eligibility.
            </span>
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <div className="bg-[#12B6B6] py-4">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-0 sm:divide-x sm:divide-white/40">
            <div className="flex items-center gap-2 sm:px-10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-government-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm tracking-wide whitespace-nowrap">Section-8 Non-Profit</span>
            </div>
            <div className="flex items-center gap-2 sm:px-10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-shield-2-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm tracking-wide whitespace-nowrap">80G Tax Exemption Available</span>
            </div>
            <div className="flex items-center gap-2 sm:px-10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bar-chart-box-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm tracking-wide whitespace-nowrap">Transparent Impact Reporting</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
